/** Every TanStack Query key in one place, so invalidation cannot miss one. */
export const qk = {
  selfProfile: (playerId: string) => ['player', 'self', playerId] as const,
  player: (playerId: string) => ['player', playerId] as const,
  building: (buildingId: string) => ['building', buildingId] as const,
  playerBuildings: (playerId: string) => ['player-buildings', playerId] as const,
  npc: (npcId: string) => ['npc', npcId] as const,
  buildingsInBounds: (areaKey: string) => ['feed', 'buildings', areaKey] as const,
  givers: (areaKey: string) => ['feed', 'givers', areaKey] as const,
  police: (areaKey: string) => ['feed', 'police', areaKey] as const,
  roamers: (areaKey: string) => ['feed', 'roamers', areaKey] as const,
  crewMap: (areaKey: string) => ['feed', 'crew-map', areaKey] as const,
  roamerConfig: () => ['config', 'roamer'] as const,
}
